
/*!
 * @pendo/components 3.25.3
 * (c) 2018-present
 */

import Color from 'color';
import colorString from 'color-string';

function normalizeHex(hex) {
  if (hex.includes('#')) {
    return hex.toUpperCase();
  }

  return `#${hex.toUpperCase()}`;
}
function getAlpha(color) {
  return Color(color).alpha();
}
function toRgbString({
  r,
  g,
  b,
  alpha
}) {
  return `rgba(${[r, g, b, alpha].join(',')})`;
}
function toHexString({
  r,
  g,
  b,
  alpha
}) {
  if (alpha < 1) {
    const hex = colorString.to.hex([Math.round(r), Math.round(g), Math.round(b), alpha]);
    return {
      hex,
      hex8: hex
    };
  }

  const hex = colorString.to.hex([Math.round(r), Math.round(g), Math.round(b)]);
  return {
    hex,
    hex8: `${hex}FF`
  };
}
function isValidHex(hex) {
  const regex = /(^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$|^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$)/;
  return typeof hex === 'string' && regex.test(hex);
}
function getColor(data) {
  let color;

  if (data && data.hsl) {
    color = Color(data.hsl);
  } else if (data && data.hex && data.hex.length > 0) {
    color = Color(data.hex);
  } else {
    color = Color(data);
  }

  if (data.alpha) {
    color.alpha(data.alpha);
  }

  const hsl = color.hsl().object();
  const hsv = color.hsv().object();

  const _color$rgb$object = color.rgb().object(),
        r = _color$rgb$object.r,
        g = _color$rgb$object.g,
        b = _color$rgb$object.b,
        alpha = _color$rgb$object.alpha;

  const _toHexString = toHexString({
    r,
    g,
    b,
    alpha
  }),
        hex = _toHexString.hex,
        hex8 = _toHexString.hex8;

  return {
    r: Math.round(r),
    g: Math.round(g),
    b: Math.round(b),
    alpha: isNaN(alpha) ? 1 : alpha,
    hex,
    hex8,
    hsv,
    hsl
  };
}
const DEFAULT_PRESETS = ['#D0021B', '#F5A623', '#F8E71C', '#8B572A', '#7ED321', '#417505', '#BD10E0', '#9013FE', '#4A90E2', '#50E3C2', '#B8E986', '#000000', '#4A4A4A', '#9B9B9B', '#FFFFFF'];
function getContrastingColor(hex) {
  if (hex.startsWith('#')) {
    hex = hex.slice(1, hex.length);
  }

  const red = parseInt(hex.substr(0, 2), 16);
  const green = parseInt(hex.substr(2, 2), 16);
  const blue = parseInt(hex.substr(4, 2), 16);
  const yiq = (red * 299 + green * 587 + blue * 114) / 1000;

  if (yiq >= 128) {
    return '#2A2C35';
  }

  return '#FFFFFF';
}

export { DEFAULT_PRESETS as D, getAlpha as a, getContrastingColor as b, getColor as g, isValidHex as i, normalizeHex as n, toRgbString as t };
